import clsx from 'clsx';
import React, { Suspense, lazy } from 'react';

import useYouTubeVideoPlaybackTracking from '@hooks/useYouTubeVideoPlaybackTracking';

import type { VideoComponentProps } from './interfaces';

const YouTubeIframe = lazy(() => import('@components/YouTube/YouTubeIframe'));

const YouTube = ({ config, content, maxWidth }: VideoComponentProps) => {
  const { handleVideoEnd, handleVideoPause, handleVideoPlay, handleVideoTimeUpdate } =
    useYouTubeVideoPlaybackTracking({ src: content.src });

  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center font-bold">
          Loading YouTube video…
        </div>
      }
    >
      <div
        className={clsx(
          'video-block mt-24 h-auto w-full border-0',
          maxWidth,
          content?.yt_short ? 'aspect-[9/16]' : 'aspect-[16/9]',
          config?.css_classes
        )}
      >
        <YouTubeIframe
          className="*:h-full *:w-full"
          onEnd={handleVideoEnd}
          onPause={handleVideoPause}
          onPlay={handleVideoPlay}
          onTimeUpdate={handleVideoTimeUpdate}
          src={content.src}
          playerVars={{
            controls: 1,
          }}
        />
      </div>
    </Suspense>
  );
};

export default YouTube;
